import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { ChevronLeft, ChevronRight, X } from 'lucide-react'; // ajout de X pour fermer

const PhotoNavigation = () => {
  const [media, setMedia] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [imagesPerSlide, setImagesPerSlide] = useState(
    window.innerWidth <= 768 ? 1 : 3,
  );
  const [selectedMedia, setSelectedMedia] = useState(null); // ✅ pour lightbox
  const intervalRef = useRef(null);
  const Url = process.env.REACT_APP_URL_DEV;

  useEffect(() => {
    const fetchMedia = async () => {
      try {
        const response = await axios.get(`${Url}/api/decouvrir/all`);
        if (response.data?.data) setMedia(response.data.data);
      } catch (err) {
        console.error('Erreur lors de la récupération :', err);
      }
    };
    fetchMedia();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setImagesPerSlide(window.innerWidth <= 768 ? 1 : 3);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (media.length > 0) {
      intervalRef.current = setInterval(() => {
        goToNext();
      }, 5000);
    }
    return () => clearInterval(intervalRef.current);
  }, [media, imagesPerSlide]);

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex - imagesPerSlide < 0
        ? Math.floor((media.length - 1) / imagesPerSlide) * imagesPerSlide
        : prevIndex - imagesPerSlide,
    );
    clearInterval(intervalRef.current);
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + imagesPerSlide) % media.length);
    clearInterval(intervalRef.current);
  };

  return (
    <div style={{ overflow: 'hidden', position: 'relative', width: '100%' }}>
      <h2 style={{ textAlign: 'center', marginBottom: '1rem' }}>
        Vidéos - Images
      </h2>

      {/* Flèches de navigation */}
      {media.length > imagesPerSlide && (
        <>
          <button onClick={goToPrevious} style={buttonStyle('left')}>
            <ChevronLeft size={24} color="#333" />
          </button>

          <button onClick={goToNext} style={buttonStyle('right')}>
            <ChevronRight size={24} color="#333" />
          </button>
        </>
      )}

      {/* Slider */}
      <div
        style={{
          display: 'flex',
          width: `${(media.length * 100) / imagesPerSlide}%`,
          transform: `translateX(-${(currentIndex * 100) / media.length}%)`,
          transition: 'transform 0.5s ease-in-out',
        }}
      >
        {media.map((item, index) => (
          <div
            key={index}
            style={{
              width: `${100 / media.length}%`,
              padding: '5px',
              boxSizing: 'border-box',
            }}
          >
            {item.Src ? (
              <img
                src={`${Url}/images/${item.Src}`}
                alt={`media-${index}`}
                style={mediaStyle}
                onClick={() =>
                  setSelectedMedia({
                    type: 'image',
                    src: `${Url}/images/${item.Src}`,
                  })
                } // ✅ clique ouvre lightbox
              />
            ) : (
              <video
                src={`${Url}/video/${item.type}`}
                controls
                style={mediaStyle}
                onClick={() =>
                  setSelectedMedia({
                    type: 'video',
                    src: `${Url}/video/${item.type}`,
                  })
                } // ✅ clique ouvre lightbox
              />
            )}
          </div>
        ))}
      </div>

      {/* ✅ Lightbox */}
      {selectedMedia && (
        <div style={lightboxOverlay}>
          <button onClick={() => setSelectedMedia(null)} style={closeButton}>
            <X size={28} color="white" />
          </button>

          {selectedMedia.type === 'image' ? (
            <img src={selectedMedia.src} alt="preview" style={lightboxMedia} />
          ) : (
            <video
              src={selectedMedia.src}
              controls
              autoPlay
              style={lightboxMedia}
            />
          )}
        </div>
      )}
    </div>
  );
};

/* Styles réutilisables */
const mediaStyle = {
  width: '100%',
  height: '320px',
  objectFit: 'cover',
  borderRadius: '10px',
  cursor: 'pointer',
};

const buttonStyle = (pos) => ({
  position: 'absolute',
  top: '50%',
  [pos]: '15px',
  transform: 'translateY(-50%)',
  background: 'white',
  border: 'none',
  borderRadius: '50%',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
  padding: '10px',
  cursor: 'pointer',
  zIndex: 10,
  transition: 'background 0.3s ease',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

const lightboxOverlay = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  background: 'rgba(0,0,0,0.8)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000,
};

const lightboxMedia = {
  maxWidth: '90%',
  maxHeight: '90%',
  borderRadius: '12px',
};

const closeButton = {
  position: 'absolute',
  top: '20px',
  right: '20px',
  background: 'transparent',
  border: 'none',
  cursor: 'pointer',
};

export default PhotoNavigation;
